"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pageTypeSiteTypeMap = exports.pageTypeContentAndPageIdMap = void 0;
const enums_1 = require("./enums");
exports.pageTypeContentAndPageIdMap = new Map(Object.keys(enums_1.PageType).map((key) => [
    enums_1.PageType[key],
    enums_1.ContentType[key],
]));
exports.pageTypeSiteTypeMap = new Map(Object.keys(enums_1.PageType).map((key) => [
    enums_1.PageType[key],
    enums_1.SiteType[key],
]));
//# sourceMappingURL=maps.js.map